module.exports = new __parcel__URL__("limewire_icon.a33049ae.svg").toString();